
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.604 17c7.925 0 12.259-6.54 12.259-12.21 0-.187-.004-.372-.012-.555A8.749 8.749 0 0021 2.012a8.623 8.623 0 01-2.474.676A4.311 4.311 0 0020.42.314a8.661 8.661 0 01-2.736 1.042A4.312 4.312 0 0014.54 0c-2.379 0-4.308 1.922-4.308 4.291 0 .337.037.664.111.979A12.249 12.249 0 011.462.786a4.284 4.284 0 001.334 5.73 4.288 4.288 0 01-1.952-.538v.055A4.297 4.297 0 004.3 10.24a4.34 4.34 0 01-1.946.074 4.311 4.311 0 004.025 2.98 8.665 8.665 0 01-5.351 1.838c-.347 0-.69-.02-1.028-.06A12.231 12.231 0 006.604 17"}})])
          )
        }
      }
    